// A small external store of named "gate" booleans that a tour step can require
// before its Next/Finish button enables (e.g. a meeting name has been typed, a
// date picked). Components hosting tour anchors publish field validity here via
// setTourGate; TourStepContent reads a single gate via useSyncExternalStore.
// Single-instance app, so a module-level store is fine.

type Listener = () => void;

let gates: Record<string, boolean> = {};
const listeners = new Set<Listener>();

const emit = (): void => {
	listeners.forEach((l) => l());
};

/** Publish whether a named requirement is currently satisfied. No-op if unchanged. */
export const setTourGate = (key: string, satisfied: boolean): void => {
	if (gates[key] === satisfied) return;
	gates = { ...gates, [key]: satisfied };
	emit();
};

export const subscribeTourGate = (listener: Listener): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

/** Stable boolean snapshot for a single gate — safe for useSyncExternalStore. */
export const getTourGateSnapshot = (key: string): boolean => gates[key] === true;
